<script>
import { useRoute } from "vue-router";
import { useOrgMemberStore } from "@/javascript/stores/orgMember";
import Index from "@/javascript/views/components/dashboard/Index.vue";
import Show from "@/javascript/views/components/dashboard/Show.vue";
import ExcelImporter from "@/javascript/views/components/excelImport/ExcelImporter.vue";
import TabsComponent from "@/javascript/views/components/dashboard/Tabs.vue";
import HeaderBar from "@/javascript/views/components/HeaderBar.vue";
import {useOrganizationStore} from "@/javascript/stores/organizations";
import {useAnalyticEventStore} from "@/javascript/stores/analyticEvents";

export default {
  components: { HeaderBar, Index, Show, TabsComponent, ExcelImporter },
  setup() {
    const route = useRoute();
    const teamStore = useOrgMemberStore();
    const organizationStore = useOrganizationStore();
    const analyticEventStore = useAnalyticEventStore();

    const recordAnalyticEvent = (action) => {
      analyticEventStore.setOrganizationId(organizationStore.organizationId);
      analyticEventStore.logEvent({ action });
    };

    return {
      route,
      teamStore,
      recordAnalyticEvent
    };
  },
  data() {
    return {
      showImportModal: false,
      // Flag to enable tabs. If only one tab is present, the tabs component will hide the header.
      hasTabs: true,
      activeTab: "team-tab",
      // Define available tabs
      tabs: [
        { id: "team-tab", label: "My Team" }
      ]
    };
  },
  computed: {
    memberId() {
      return this.route.params.id;
    },
    canCreate() {
      return this.teamStore.permissions && this.teamStore.permissions.create;
    }
  },
  watch: {
    'teamStore.organizationId'() {
      this.teamStore.loadData();
    },
    memberId(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.teamStore.loadData();
      }
    }
  },
  mounted() {
    this.teamStore.loadData();
  },
  methods: {

    showModal() {
      this.showImportModal = true;
      this.recordAnalyticEvent('dashboard-import-team-members');
    }
  }
};
</script>

<template>
  <div>
    <!-- Show detailed view if a team member is selected -->
    <div v-if="memberId && teamStore.currentRecord">
      <show
        :model-store="teamStore"
        editable
      />
    </div>
    <!-- Otherwise show list view -->
    <div v-else>
      <!-- Header Bar with title and Import button -->
      <div class="px-4">
        <header-bar
          title="My Team"
        >
          <template #buttons>
            <button
              v-if="canCreate"
              class="btn-outline"
              @click="showModal"
            >
              Add Team Members
            </button>
          </template>
        </header-bar>
      </div>
      <!-- Main content with tabs -->
      <div
        v-if="hasTabs"
        class="mt-2 pt-2 w-full p-4 mx-auto"
      >
        <div class="breakpoint-container relative rounded-xl overflow-hidden border border-gray-300 text-xs">
          <tabs-component
            v-model="activeTab"
            :tabs="tabs"
            @tab-changed="handleTabChange"
          >
            <!-- My Team tab: Wrap the Index component -->
            <template #team-tab>
              <index :model-store="teamStore" />
            </template>
          </tabs-component>
        </div>
      </div>
      <!-- Fallback: If tabs are not enabled, show the Index component -->
      <div
        v-else
        class="breakpoint-container mt-4"
      >
        <index :model-store="teamStore" />
      </div>
      <!-- Import Modal -->
      <excel-importer
        v-if="showImportModal"
        :model-store="teamStore"
        @close="showImportModal = false"
      />
    </div>
  </div>
</template>
